import ajax from "../../lib/appfuse-react/core/ajax";

const utilService = {
    findCounty: async () => {
        const response = await ajax.get("counties/findAll");
        return response.data;
    }
}

export default utilService;